import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import Stack from '@mui/material/Stack';

import SchedulingHeader from './SchedulingHeader';
import BlankContent from '../common/BlankContent';
import FormLayout from "../patientSignup/FormLayout";
import NewSessionButton from '../sessions/NewSessionButton';

const ScheduleManuallyScreen = props => {
  const body = (
    props?.hideBodyText ? '' :
    props?.selectedPatient 
    ? 'Automated scheduling is not available for this session type.'
    : (props.scheduleManuallyMessage || 'Your provider will work with you directly to find an appointment time.')
  );
  const buttonHelperText = (
    props?.selectedPatient
    ? 'You can schedule manually with this patient using the button below.'
    : (props.scheduleManuallyMessage ? '' : 'After you complete registration, your provider will work with you directly to book an appointment.')
  );
  return (
    <FormLayout
      maxWidth={{xs: '464px', sm: '800px'}}
    >
      <SchedulingHeader
        provider={props.selectedProvider}
        sessionType={props.sessionType}
        onBack={props.onBack}
      />
      <Stack paddingTop={'2em'}>
        <BlankContent
          title={null}
          body={body}
          iconSize='4em'
          Icon={CalendarIcon}
          buttonHelperText={buttonHelperText}
          ButtonComponent={
            <Stack spacing={1}>
              {
                !props?.selectedPatient &&
                <Button
                  variant='primaryGradient'
                  color='info'
                  onClick={props.onContinue}
                  style={{marginTop: '4em'}}
                >
                  Continue
                </Button>
              }
              {
                !props?.selectedPatient &&
                !props.hideScheduleAutomaticallyButton &&
                <Button
                  variant='primaryOutline'
                  size='medium'
                  onClick={props.onScheduleNow}
                >
                  Schedule automatically instead
                </Button>
              }
              {
                props?.selectedPatient &&
                props?.sessionType &&
                <NewSessionButton
                  sessionType={props?.sessionType}
                  patient={props?.selectedPatient}
                  buttonText='Schedule Manually'
                />
              }
            </Stack>
          }
        />
      </Stack>
    </FormLayout>
  );
};

ScheduleManuallyScreen.defaultProps = {

};

ScheduleManuallyScreen.propTypes = {
  selectedProvider: PropTypes.object.isRequired,
  sessionType: PropTypes.object.isRequired,
};

export default ScheduleManuallyScreen;
